import { Select } from '@livingdesign/react'
import React, { useState, useEffect } from 'react'

export const QA_ID_PREFIX = "CommonFieldSelect";

function CommonFieldSelect({
    defaultValue,
    handleChange,
    value,
    options = [],
    name,
    label,
    style,
    className,
    error,
    disabled,
    onBlur,
}) {

    useEffect(() => {
        if(!value && defaultValue) {
            handleChange({target: {value: defaultValue}});
        }
    }, [defaultValue, value]);

    return (
        <Select
            name={name}
            label={label}
            UNSAFE_style={style}
            error={error}
            UNSAFE_className={className}
            defaultValue={defaultValue}
            value={value}
            onChange={handleChange}
            onBlur={onBlur}
            disabled={disabled}
            data-testid={`${QA_ID_PREFIX}-select`}
        >
            {options.map((option, index) => (
                <option key={option.value} value={option.value} data-testid={`${QA_ID_PREFIX}-option-${index}`}>
                    {option.label}
                </option>
            ))}
        </Select>
    )
}

export default CommonFieldSelect